module.exports = __webpack_public_path__ + "static/search-53da46e4a8cdd4260623.png";